import { captureException, withScope } from '@sentry/ember';
export default function captureItemFeeMembershipConstraint(itemId, feeId) {
  withScope(scope => {
    scope.setContext('args', {
      itemId,
      feeId
    });
    captureException(new Error('Tried to create an item fee membership for a fee that has a product set'));
  });
}